export enum OrderItemButtonType {
  REOPEN = 'reopen',
  CANCELREOPEN = 'cancelReopen',
  SETUP = 'setup',
  NEXT = 'next',
  MANUAL_CUTTING = 'manualCutting',
  MANUAL_SORTING = 'manualSorting'
}
